import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';

@Component({
  selector: 'dashboard-tabel',
  templateUrl: './dashboard-tabel.component.html',
  styleUrls: ['./dashboard-tabel.component.scss']
})
export class DashboardTabelComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
   
      this.pageCount = 0;
      this.pagesContainer = new Array(0);
      this.pagger = 0
      this.getData({ take: 10, skip: 0 });
    
  }

  constructor(private dashboardService: DashboardService) { }
  @Input() options: any;
  data: any[];
  public pagger: number = 0;
  pageCount: number = 0
  pagesContainer: any[] = new Array(0);
  ngOnInit() {
    this.pagesContainer = new Array(0);
    this.getData({ take: 10, skip: 0 });
  }
  prepareSearchObject(take: number, skip: number) {
    var searchObject = { skip: skip, take: take };

    return searchObject
  }
  prevPage() {
    this.pagger--;

    this.getData(this.prepareSearchObject(10, this.pagger * 10));
  }

  nextPage() {
    this.pagger++;
    this.getData(this.prepareSearchObject(10, this.pagger * 10));
  }

  getSearchPage(pagger) {
    this.pagger = pagger;
    this.getData(this.prepareSearchObject(10, pagger * 10));

  }
  getData(searchObject) {
    if (this.options.type == "new") {
      this.dashboardService.getNewShipments(this.options.date, searchObject.take, searchObject.skip, (res) => {
        this.data = res.Results
        this.pageCount = res.Count
        this.pagesContainer = new Array(Math.ceil(this.pageCount / 10))
      }, (err) => {
      })
    }
    else if (this.options.type == "returned") {
      this.dashboardService.getReturnedShipment(this.options.date, searchObject.take, searchObject.skip,
        (res) => {
          this.data = res.Results
          this.pageCount = res.Count
          this.pagesContainer = new Array(Math.ceil(this.pageCount / 10))
        },
        (err) => {
        })
    }

  }
  fixDecimals(value: any = 0) {
    if (value != 0 && value != null) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      if (value || value == 0)
        return '0.00';
      else
        return '';
    }
  }


}
